export var rem = function (value) { return value + "rem"; };
export var vh = function (value) { return value + "vh"; };
export var vw = function (value) { return value + "vw"; };
export var toREM = function (value) {
    return typeof value === 'string' || value === 0 ? "" + value : rem(value);
};
// trbl = top, right, bottom, left
export var trbl = function (top, right, bottom, left) {
    return toREM(top) + " " + toREM(right) + " " + toREM(bottom) + " " + toREM(left);
};
// txb = top, x, bottom
// eslint-disable-next-line id-length
export var txb = function (top, x, bottom) {
    return toREM(top) + " " + toREM(x) + " " + toREM(bottom);
};
// eslint-disable-next-line id-length
export var yx = function (y, x) { return toREM(y) + " " + toREM(x); };
export var border = function (width, style, colour) {
    return width + "px " + style + " " + colour;
};
var units = { rem: rem, vh: vh, vw: vw, trbl: trbl, txb: txb, yx: yx, border: border };
export default units;
//# sourceMappingURL=units.js.map